import { render, staticRenderFns } from "./ModalMethod.vue?vue&type=template&id=b0b4a238&"
import script from "./ModalMethod.vue?vue&type=script&lang=js&"
export * from "./ModalMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports